import { render, staticRenderFns } from "./CompassHUD.vue?vue&type=template&id=9d15bfcc&"
import script from "./CompassHUD.vue?vue&type=script&lang=js&"
export * from "./CompassHUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports